import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

import { ModalBase } from '../../../common/components';
import models from './models';
import CounterIcons from './CounterIcons';

function TipsModal() {
  const dispatch = useDispatch();
  const {
    modals: { tipsModal: modalOpen },
    theme: { tipsModalContent: modalContent },
  } = useSelector(store => store);
  const [ currentPage, setCurrentPage ] = useState(0);
  const [ pages, setPages ] = useState([]);

  useEffect(() => {
    if (modalContent) {
      setPages(modalContent);
    } else {
      setPages(models);
    }
  }, []);

  function handleNext() {
    setCurrentPage(currentPage + 1);
  }

  function handlePrev() {
    setCurrentPage(currentPage - 1);
  }

  function closeModal() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'tipsModal' });
    setCurrentPage(0);
  }

  let title = 'Title';
  let body = 'Body Text';
  let imgUrl = 'https://google.com';

  if (pages[currentPage]) {
    title = pages[currentPage].title;
    body = pages[currentPage].body;
    imgUrl = pages[currentPage].imgUrl;
  }

  return (
    <ModalBase
      isOpen={modalOpen}
      id="tips-modal"
      closeModalAction={() => closeModal()}
      style={{ borderRadius: '5px' }}
      allowOverlayClickClose
      width="1000px"
      paddingTop="30px"
      paddingBottom="30px"
      paddingLeft="100px"
      paddingRight="100px"
    >
      {/* this is load imgs onto the page so that there's not a delay
          when you go between screens to load the imgs */}
      <div style={{ display: 'none' }}>
        {pages.map((p) => <img key={p.title} alt={p.title} src={p.imgUrl} />)}
      </div>

      <div className="row">
        <h6 className="text-muted fw-bold">Tips for using this tool:</h6>
      </div>
      <div className="row">
        <h4>{`${(currentPage || 0) + 1}. ${title}`}</h4>
      </div>
      <div className="row">
        <p style={{ maxWidth: '800px' }}>{body}</p>
      </div>
      <div className="row">
        <img alt={title} src={imgUrl} style={{ width: '800px' }} />
      </div>

      <div className="row justify-content-center mt-5">
        <CounterIcons pages={pages} currentPage={currentPage} />
      </div>

      <div className="row justify-content-center mt-5">
        <button
          type="button"
          disabled={currentPage === 0}
          className="btn btn-outline-primary me-5"
          style={{ width: '120px' }}
          onClick={handlePrev}
        >
          <FontAwesomeIcon className="me-2" icon={faChevronLeft} />
          Previous
        </button>
        {(currentPage >= (pages.length - 1)) ? (
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{ width: '120px', paddingTop: '0px', paddingBottom: '0px' }}
            onClick={closeModal}
          >
            Finish
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{ width: '120px', paddingTop: '0px', paddingBottom: '0px' }}
            onClick={handleNext}
          >
            Next
            <FontAwesomeIcon className="ms-2" icon={faChevronRight} />
          </button>
        )}
      </div>
    </ModalBase>
  );
}

export default TipsModal;
